import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <section className="relative">
      {/* Curved top */}
      <div 
        className="absolute top-0 left-0 right-0 h-20 bg-white"
        style={{ 
          borderBottomLeftRadius: '50% 100%',
          borderBottomRightRadius: '50% 100%'
        }}
      />
      
      <div className="py-24 bg-[#faf8f5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            {/* Left Content */}
            <div className="space-y-6">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
                Proudly Serving Victoria's Grain Growers
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Located in Wycheproof, in the heart of Victoria's grain growing region, we provide essential storage and export services to local and regional growers.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Our modern facilities and experienced team ensure your grain is handled with the care and professionalism it deserves.
              </p>
              <Link
                to="/about"
                className="inline-block px-6 py-3 bg-yellow-500 text-gray-900 font-semibold rounded-md hover:bg-yellow-400 transition-all duration-300 mt-2"
              >
                Discover Our Story
              </Link>
            </div>

            {/* Right Card - Visit Us */}
            <div className="bg-white rounded-lg shadow-sm border-l-4 border-yellow-400 p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Visit Us
              </h3>
              
              <div className="space-y-5">
                {/* Address */}
                <div>
                  <p className="text-sm text-gray-500 mb-1">Address</p>
                  <p className="text-gray-900 font-medium">35 Milburns Road</p>
                  <p className="text-gray-900 font-medium">Wycheproof VIC 3527</p>
                  <p className="text-gray-900 font-medium">Australia</p>
                </div>

                {/* Phone */}
                <div>
                  <p className="text-sm text-gray-500 mb-1">Phone</p>
                  <a
                    href="tel:+61354937444"
                    className="text-yellow-600 font-medium hover:text-yellow-700 transition-colors"
                  >
                    +61 3 5493 7444
                  </a>
                </div>

                {/* Email */}
                <div>
                  <p className="text-sm text-gray-500 mb-1">Email</p>
                  <a
                    href="mailto:wyche-admin@wychegrain.com.au"
                    className="text-yellow-600 font-medium hover:text-yellow-700 transition-colors"
                  >
                    wyche-admin@wychegrain.com.au
                  </a>
                </div>

                {/* Business Hours */}
                <div>
                  <p className="text-sm text-gray-500 mb-1">Business Hours</p>
                  <p className="text-gray-900 font-medium">8am - 4:30pm</p>
                  <p className="text-gray-700">Monday to Friday</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
